export class QuadraDto {
  label: string;
  integracaoId: number;
  arquivoNome: string;
  arquivoUrlStorage: string;
  dataCriacao: string;
  dataAtualizacao: string;
  coords: number[][];
}
